import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'app-bt-layout',
    templateUrl: './bt-layout.component.html',
    styleUrls: ['./bt-layout.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BtLayoutComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
